import React from 'react';
import '../style/Section1.scss';
import SectionTitle from "../components/SectionTitle";

function Section1(props) {
  return (
      <div id={'Section1'}>
        <SectionTitle title={'TECH SPECS'}/>
        <div className="tech-item-wrapper">
          <TechItem mainText={'4,500'} subText={'Real Transactions per Second per Micro-chain'} description={'Add additional interoperable Micro-chains to handle as many transactions as needed.'}/>
          <TechItem mainText={'1-3 Second'} subText={'Transaction Finalization'} description={'Rapid finalization of your transactions for trading, games, or anything that relies on speed.'}/>
          <TechItem mainText={'13,500'} subText={'Transactions Per Block'} description={'Large block sizes to support scalability and low transaction fees.'}/>
          <TechItem mainText={'10%'} subText={'Approximate Validator Yield'} description={'Validators are incentivized to secure VERIA by receiving an average yield of 10% per year.'}/>
          <TechItem mainText={'MEV'} subText={'Not Possible'} description={'Validators are not informed in advance, therefore they cannot front run your transactions.'}/>
          <TechItem mainText={'NO-CODE'} subText={'DApp Builder'} description={'We built a no-code toolkit to allow anyone to build onchain apps and games.'}/>
          <TechItem mainText={'LOW'} subText={'Token Unlocks'} description={'VERIA fundraise is less than $15m, and team allocations are modest, therefore future token unlocks are modest and manageable.'}/>
          <TechItem mainText={'FEE SHARE'} subText={'System'} description={'Transaction fees are shared between wallets, smart contracts, and nodes. Build or set up a node on VERIA and get paid.'}/>
        </div>
      </div>
  );
}

const TechItem = ({mainText, subText, description}) => {
  return (
      <div className='tech-item'>
          <div className="main-wrapper">
            <div className="main-text">
              {mainText}
            </div>
            <div className="sub-text">
              {subText}
            </div>
          </div>
        <div className="description-wrapper">
          {description}
        </div>
      </div>
  )
}

export default Section1;